import { JobCard } from './JobCard';
import styled from 'styled-components6';
import { PluginWorkSite } from 'rwl-shared/dist/models';
import { ForwardedRef, forwardRef } from 'react';

const StyledList = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: var(--rwl-spacing-lg);
`;

type JobCardListProps = {
    jobList: PluginWorkSite[];
    onJobCardClicked?: (jobId: string) => void;
};

export const JobCardList = forwardRef(
    (
        { jobList, onJobCardClicked }: JobCardListProps,
        ref: ForwardedRef<HTMLElement>
    ): JSX.Element => {
        return (
            <StyledList>
                {jobList.map((j, idx, list) => {
                    const additionalProps =
                        idx === list.length - 1 ? { ref } : {};
                    return (
                        <JobCard
                            job={j}
                            key={j.id}
                            onJobCardClicked={() => onJobCardClicked?.(j.id)}
                            {...additionalProps}
                        />
                    );
                })}
            </StyledList>
        );
    }
);
